// @format

import { showNotice } from './notice';

export function initCreditBatches(): void {
  $(document).on('change', '#credit-batches-company-dropdown select', e => {
    $('#credit-batches-company-dropdown').submit();
  });

  $(document).on('keydown', '.user-credit-batch-table td.shares input', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      (this as HTMLInputElement).blur();
    }
  });

  $(document).on('change', '.user-credit-batch-table td.shares input', function () {
    const $input = $(this);
    const $row = $input.closest('tr');
    const assignmentId = $row.data('assignment-id');
    const shares = parseInt(String($input.val() ?? ''), 10);
    if (!assignmentId || isNaN(shares)) return;

    const token = $('meta[name="csrf-token"]').attr('content') || '';
    $input.prop('disabled', true);
    $.ajax({
      url: `/credit_batch_share_assignments/${assignmentId}`,
      method: 'PATCH',
      data: { shares },
      headers: { 'X-CSRF-Token': token },
      dataType: 'json',
    }).done((res) => {
      if (res && res.success) {
        $row.find('td.remaining-credits').text(res.remaining);
        showNotice(`Shares updated (${shares}). Remaining: ${res.remaining}.`, 'success', 3000);
      } else {
        const msg = (res && res.error) || 'Could not update shares';
        showNotice(msg, 'danger');
      }
    }).fail((xhr) => {
      const msg = (xhr.responseJSON && xhr.responseJSON.error) || `Could not update shares (HTTP ${xhr.status})`;
      showNotice(msg, 'danger');
    }).always(() => {
      $input.prop('disabled', false);
    });
  });

  $(document).on('click', '.user-credit-batch-table th.sortable', function () {
    const $th = $(this);
    const column = String($th.data('sort-column'));
    const $table = $th.closest('table');
    const $tbody = $table.find('tbody');
    const dir = $th.hasClass('sort-asc') ? 'desc' : 'asc';

    $table.find('th.sortable')
      .removeClass('sort-asc sort-desc')
      .find('i.sort-icon')
      .removeClass('fa-sort-up fa-sort-down')
      .addClass('fa-sort');
    $th.addClass(`sort-${dir}`)
      .find('i.sort-icon')
      .removeClass('fa-sort')
      .addClass(dir === 'asc' ? 'fa-sort-up' : 'fa-sort-down');

    const valueOf = (row: HTMLElement): number => {
      const cell = row.querySelector(`td.${column}`);
      if (!cell) return 0;
      const input = cell.querySelector('input') as HTMLInputElement | null;
      const text = input ? input.value : cell.textContent || '';
      const n = parseFloat(text.trim());
      return isNaN(n) ? 0 : n;
    };
    const secondary = (row: HTMLElement): string => {
      const cell = row.querySelector('td.user');
      return cell ? (cell.textContent || '').trim() : '';
    };

    const rows = $tbody.find('tr').toArray();
    rows.sort((a, b) => {
      const diff = valueOf(a) - valueOf(b);
      if (diff !== 0) return dir === 'asc' ? diff : -diff;
      return secondary(a).localeCompare(secondary(b));
    });
    rows.forEach(r => $tbody.append(r));
  });
}
